import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../utils/api";
import { ChartPieSlice } from "@phosphor-icons/react";

const AttemptedStudent = () => {
  const [students, setStudents] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  async function fetchData(page = 1) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getAttemptedStudentsDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("page", page); // pagination param

      const response = await api.post("student/studentCurl", fd);

      if (response.data.success && response.data.data?.length >= 0) {
        setStudents(response.data.data);
        setTotalPages(response.data.totalPages || 1);
        setCurrentPage(page);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  useEffect(() => {
    fetchData(currentPage);
  }, []);

  const handlePageChange = (page) => {
    if (page !== currentPage && page !== "...") {
      fetchData(page);
    }
  };

  const createPagination = () => {
    const pages = [];
    const total = totalPages;
    const current = currentPage;

    if (total <= 5) {
      for (let i = 1; i <= total; i++) pages.push(i);
    } else {
      if (current <= 3) {
        pages.push(1, 2, 3, "...", total);
      } else if (current >= total - 2) {
        pages.push(1, "...", total - 2, total - 1, total);
      } else {
        pages.push(1, "...", current, "...", total);
      }
    }
    return pages;
  };

  return (
    <div className="dashboard-body">
      <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
        <div className="breadcrumb mb-24">
          <ul className="flex-align gap-4">
            <li>
              <Link
                to="/"
                className="text-gray-200 fw-normal text-15 hover-text-main-600"
              >
                Home
              </Link>
            </li>
            <li>
              <span className="text-gray-500 fw-normal d-flex">
                <i className="ph ph-caret-right"></i>
              </span>
            </li>
            <li>
              <span className="text-main-600 fw-normal text-15">
                Attempted Student Details
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="card">
        <div
          className="card-header table-responsive"
          style={{ padding: "10px" }}
        >
          <table id="assignmentTable" className="table table-striped">
            <thead style={{ borderBottom: "1px #D5DBE7 solid" }}>
              <tr>
                <th className="h5 text-gray-300" scope="col">
                  ID
                </th>
                <th className="h5 text-gray-300" scope="col">
                  Name
                </th>
                <th className="h5 text-gray-300" scope="col">
                  Roll No.
                </th>
                <th className="h5 text-gray-300" scope="col">
                  Class
                </th>
                <th className="h5 text-gray-300" scope="col">
                  Branch
                </th>
                <th className="h5 text-gray-300" scope="col">
                  Overview
                </th>
              </tr>
            </thead>
            <tbody>
              {students.map((student, index) => (
                <tr key={student.studentId || index}>
                  <td className="h6 mb-0 fw-medium text-gray-300">
                    {index + 1}
                  </td>
                  <td className="h6 mb-0 fw-medium text-gray-300">
                    {student.firstName}
                  </td>
                  <td className="h6 mb-0 fw-medium text-gray-300">
                    {student.roll}
                  </td>
                  <td className="h6 mb-0 fw-medium text-gray-300">
                    {student.className}
                  </td>
                  <td className="h6 mb-0 fw-medium text-gray-300">
                    {student.branchName}
                  </td>
                  <td className="h6 mb-0 fw-medium text-gray-300">
                    <Link to={`/performance/${student.studentId}`}>
                      <ChartPieSlice size={22} color="blue" />
                    </Link>
                  </td>
                </tr>
              ))}
              {students.length === 0 && (
                <tr>
                  <td className="h6 mb-0 fw-medium text-gray-300">
                    No students found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {students.length > 0 && (
          <div>
            <div
              className="card-footer d-flex justify-content-end flex-wrap"
              style={{ backgroundColor: "" }}
            >
              <ul className="pagination flex-align flex-wrap">
                {createPagination().map((page, index) => (
                  <li
                    key={index}
                    className={`page-item ${
                      currentPage === page ? "active" : ""
                    }`}
                  >
                    {page === "..." ? (
                      <button
                        className="page-link h-32 w-32 flex-center text-15 rounded-8 fw-medium"
                        style={{ backgroundColor: "white" }}
                      >
                        <span className="page-link">...</span>
                      </button>
                    ) : (
                      <button
                        className="page-link h-32 w-32 flex-center text-15 rounded-8 fw-medium"
                        style={{ backgroundColor: "white" }}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AttemptedStudent;
